import { render } from "./DashboardExpenseTab.vue?vue&type=template&id=f1ede0b2&scoped=true"
import script from "./DashboardExpenseTab.vue?vue&type=script&lang=js"
export * from "./DashboardExpenseTab.vue?vue&type=script&lang=js"

import "./DashboardExpenseTab.vue?vue&type=style&index=0&id=f1ede0b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ede0b2"]])

export default __exports__